import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { checkAndRefreshToken } from 'utils/authUtils';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';


export const notificationApi = createApi({
  reducerPath: 'notifications',
  baseQuery: createBaseQueryWithReauth('/notifications'),
 

  tagTypes: ['Notifications'],

  endpoints: builder => ({
    getNotifications: builder.query({
      query: ({ page = 1 } = {}) => {

        const params = {
          page
        };
        return {
          url: `?page=${page}`,
          method: 'GET',
          params,
        };
      },
      transformResponse: (response, meta) => {
        const pagination = {
          currentPage: meta.response.headers.get('x-pagination-current-page'),
          pageCount: meta.response.headers.get('x-pagination-page-count'),
          perPage: meta.response.headers.get('x-pagination-per-page'),
          totalCount: meta.response.headers.get('x-pagination-total-count'),
        };
        return { data: response, pagination };
      },
      providesTags: ['Notifications'],
    }),

    readNotifications: builder.mutation({
      query: (ids) => ({
        url: `/read?ids=${ids}`,
        method: 'POST',

      }),
      invalidatesTags: ['Notifications'],
    }),

  }),
});

export const {
  useGetNotificationsQuery,
  useReadNotificationsMutation
} = notificationApi;
